import * as m from '$paraglide/messages';
import { type DateValue, getLocalTimeZone } from '@internationalized/date';

export const DEFAULT_NUMBER_OF_DAY_TO_ADD = 1;

export function calculateNumberOfNights(start: DateValue, end: DateValue) {
	const diffInMs = end.toDate(getLocalTimeZone()).getTime() - start.toDate(getLocalTimeZone()).getTime();
	const daysDiff = Math.round(diffInMs / (1000 * 60 * 60 * 24));

	return daysDiff;
}

export function displayNumberOfNights(start: DateValue, end: DateValue) {
	const numberOfNights = calculateNumberOfNights(start, end);
	const text = numberOfNights > 1 ? m.date_range_picker__night_count_placeholder__other() : m.date_range_picker__night_count_placeholder__one();

	return `${numberOfNights} ${text}`;
}
